/**
 * Chrome re-runs password autofill when a password input becomes type="text"
 * and copies the password into the field before it. Put those fields back.
 */
export function restoreFieldsFilledWithPassword(
  passwordValue: string,
  fields: Array<{ element: HTMLInputElement; savedValue: string }>,
): void {
  if (!passwordValue) {
    return;
  }

  fields.forEach(({ element, savedValue }) => {
    if (element.value === passwordValue && element.value !== savedValue) {
      element.value = savedValue;
      element.dispatchEvent(new Event('input', { bubbles: true }));
    }
  });
}
